import { defineStore } from 'pinia'
import { useSyncData } from '@/composables/useSyncData'
import type { Form } from '@/_api/models/form'

export const useFormStore = defineStore('form', () => {
  const { $api, $grants, $features } = useNuxtApp()
  const authStore = useAuthStore()

  const accountId = computed(() => authStore.activeGuid)

  const {
    items: forms,
    count,
    hydrated,
    syncState,
    isSyncing,
    syncProgress,
    sync: _sync,
    findById,
  } = useSyncData<Form>({
    service: $api.form,
    key: 'forms',
    accountId,
    grants: { form: ['view'] },
  })

  const sync = async (options?: { force?: boolean; change?: boolean }) => {
    // Feature flag check
    if ($features && !$features.get('forms')) {
      return
    }

    // Permission check
    if ($grants && !$grants.all({ form: ['view'] })) {
      return
    }

    await _sync(options)
  }

  const syncDate = computed(() => syncState.value.date)

  const all = computed(() => forms.value)

  return {
    forms,
    count,
    hydrated,
    syncState,
    isSyncing,
    syncProgress,
    syncDate,
    sync,
    findById,
    all,
  }
})
